module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-white-1-fbb7118b0eba4dbe72022ce0e6f8cd0f.webp";